import * as React from "react";

import { Link, useNavigate } from "react-router-dom";
import logo from "./../../images/white-logo.png";

function Footer() {
  const navigate = useNavigate();
  return (
    <main className="sec-padd-t">
      <footer>
        <div className="container">
          <div className="row g-md-5 g-4">
            <div className="col-lg col-md-3 col-sm-4 col-6">
              <h4>About</h4>
              <ul>
                <li>
                  <a
                    onClick={() => {
                      navigate("/our-story");
                    }}
                  >
                    Our Story
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-lg col-md-3 col-sm-4 col-6">
              <h4>Industries</h4>
              <ul>
                <li>
                  <a
                    onClick={() => {
                      navigate("/energy-utilities");
                    }}
                  >
                    Energy &amp; Utilities
                  </a>
                </li>
                <li>
                  <a
                    onClick={() => {
                      navigate("/financial-services");
                    }}
                  >
                    Financial Services{" "}
                  </a>
                </li>
                <li>
                  <a
                    onClick={() => {
                      navigate("/healthcare");
                    }}
                  >
                    Healthcare{" "}
                  </a>
                </li>
                <li>
                  <a
                    onClick={() => {
                      navigate("/public-sector-services");
                    }}
                  >
                    Public Sector Services{" "}
                  </a>
                </li>
                <li>
                  <a
                    onClick={() => {
                      navigate("/insurance");
                    }}
                  >
                    Insurance{" "}
                  </a>
                </li>
                <li>
                  <a
                    onClick={() => {
                      navigate("/retail");
                    }}
                  >
                    Retail{" "}
                  </a>
                </li>
                <li>
                  <a
                    onClick={() => {
                      navigate("/manufacturing");
                    }}
                  >
                    Manufacturing{" "}
                  </a>
                </li>
                <li>
                  <a
                    onClick={() => {
                      navigate("/igmaing");
                    }}
                  >
                    iGaming{" "}
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-lg col-md-3 col-sm-4 col-6">
              <h4>Offerings</h4>
              <ul>
                <li>
                  <a
                    onClick={() => {
                      navigate("/analytics");
                    }}
                  >
                    Analytics
                  </a>
                </li>
                <li>
                  <a
                    onClick={() => {
                      navigate("/application-development");
                    }}
                  >
                    Application Development{" "}
                  </a>
                </li>
                <li>
                  <a
                    onClick={() => {
                      navigate("/it-managed-services");
                    }}
                  >
                    IT Managed Services{" "}
                  </a>
                </li>
                <li>
                  <a
                    onClick={() => {
                      navigate("/big-data");
                    }}
                  >
                    Big Data{" "}
                  </a>
                </li>
                <li>
                  <a
                    onClick={() => {
                      navigate("/devops");
                    }}
                  >
                    DevOps{" "}
                  </a>
                </li>
                <li>
                  <a
                    onClick={() => {
                      navigate("/mobility-solutions");
                    }}
                  >
                    Mobility Solutions{" "}
                  </a>
                </li>
                <li>
                  <a
                    onClick={() => {
                      navigate("/testing");
                    }}
                  >
                    Testing Services{" "}
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-lg col-md-3 col-sm-4 col-6">
              <h4>Career</h4>
              <ul>
                <li>
                  <a
                    onClick={() => {
                      navigate("/careers");
                    }}
                  >
                    Career
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-lg col-md-3 col-sm-4 col-6">
              <h4>Connect</h4>
              <ul>
                <li>
                  <a
                    onClick={() => {
                      navigate("/connect");
                    }}
                  >
                    Contact Us
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="last_footer">
            <div className="row g-4">
              <div className="footer_logo">
                <img src={logo} alt="logo" />
              </div>
              <h3>
                +1 585-705-8498 • &nbsp;455 N Cityfront Plaza Drive,
                <br />
                Suite # 3100, Chicago, IL - 60611 •
                &nbsp;info@cylontechnology.com
              </h3>

              <div className="btn_spacet text-center">
                <Link href="#" className="btn_small outline_white">
                  Learn More
                </Link>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </main>
  );
}

export default Footer;
